module.exports = __webpack_public_path__ + "assets/img/banner_second.3fd65630.png";